module.exports = __webpack_public_path__ + "img/package-3.eebed174.png";